import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import FileUploader from 'components/FileUploader';
import { useFormikContext } from 'formik';
import React, { useState, useCallback } from 'react';
import { PersonalDocumentType } from 'v2/components/Pages/AddBankAccount/Stepper/form';
import { CurrencyId } from 'v2/interfaces/financial';

import type { INewAccount } from 'v2/interfaces/financial';

interface IProps {
  hasVideo: boolean;
  docType: string;
  mediaPreview: any;
  onChangeDocType: () => void;
  setMediaPreview: (name: string, preview: any) => void;
}

const PersonalDocuments = ({ hasVideo, docType, mediaPreview, onChangeDocType, setMediaPreview }: IProps) => {
  const { values, setSubmitting, setFieldValue } = useFormikContext<INewAccount>();
  const [imgTitle, setImgTitle] = useState('Envie-nos uma foto da sua CNH no campo abaixo. A CNH deve estar aberta, mostrando frente e verso.');
  const [imgError, setImgError] = useState('');
  const pathName = window.location.pathname;
  const isRefundAccount = pathName.includes('bank-account-refund');
  const isBRLSelected = values.currency === CurrencyId.BRL;
  const isUSDSelected = values.currency === CurrencyId.USD;

  const handleUploadEvents = (event: string, message?: string) => {
    if (event === 'uploading') {
      setSubmitting(true);
      return;
    }

    if (event === 'error') {
      setImgError(message);
      setSubmitting(false);
    }
  };

  const handleMediaChange = useCallback(
    (name: string, id: number, preview: any) => {
      setMediaPreview(name, preview);
      setFieldValue('imgsIds', { ...values.imgsIds, [name]: id });
      setSubmitting(false);
    },
    [setFieldValue, setMediaPreview, setSubmitting, values.imgsIds]
  );

  const handleChangeImgLabels = () => {
    setImgTitle(
      docType === PersonalDocumentType.CNH
        ? 'Envie-nos fotos do seu RG e CPF nos campos abaixo.'
        : 'Envie-nos uma foto da sua CNH no campo abaixo. A CNH deve estar aberta, mostrando frente e verso.'
    );
    onChangeDocType();
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant='subtitle2'>
          {isUSDSelected
            ? // eslint-disable-next-line max-len
              'Envie-nos fotos do Documento de Constituição de Empresa (Article of Incorporation) ou do Employer Identification Number (EIN) expedido pelo IRS no campo abaixo.'
            : imgTitle}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        {docType === PersonalDocumentType.CNH ? (
          <div className='component__item'>
            <FileUploader
              onChange={handleMediaChange}
              fileName='imgDocCNH'
              defaultPreview={mediaPreview['imgDocCNH']}
              type='image'
              uploadType='mpg_docs'
              label={values.currency !== 2 ? 'CNH' : ''}
              onEvent={handleUploadEvents}
              isRefundAccount={isRefundAccount}
            />
          </div>
        ) : (
          <div>
            <div className='component__item'>
              <FileUploader
                onChange={handleMediaChange}
                fileName='imgDocRG'
                defaultPreview={mediaPreview['imgDocRG']}
                type='image'
                uploadType='mpg_docs'
                label='RG'
                onEvent={handleUploadEvents}
                isRefundAccount={isRefundAccount}
              />
            </div>
            <div className='m16'></div>
            <div className='component__item'>
              <FileUploader
                onChange={handleMediaChange}
                fileName='imgDocCPF'
                defaultPreview={mediaPreview['imgDocCPF']}
                type='image'
                uploadType='mpg_docs'
                label='CPF'
                onEvent={handleUploadEvents}
                isRefundAccount={isRefundAccount}
              />
            </div>
          </div>
        )}
      </Grid>

      <Grid item xs={12}>
        <Typography variant='subtitle2'>Envie arquivos nos formatos: JPG, PNG ou PDF. De no máximo 2mb.</Typography>
      </Grid>

      {isBRLSelected && (
        <Grid item xs={12}>
          <Typography variant='subtitle2'>
            {docType === 'cnh' ? 'Não possui CNH?' : 'Possui CNH?'}{' '}
            <span style={{ color: '#2980b9', cursor: 'pointer' }} onClick={handleChangeImgLabels}>
              Clique aqui.
            </span>
          </Typography>
        </Grid>
      )}

      <br />

      {hasVideo && (
        <>
          <Grid item xs={12}>
            <Divider variant='middle' style={{ margin: 0 }} />

            <br />

            <div className='bank__modal-title'>
              Envie-nos um vídeo com 3 a 7 segundos de duração, onde você apareça segurando o documento enviado acima com a frente (lado da foto)
              virado para a câmera no campo abaixo.
            </div>

            <br />

            <div className='component__item'>
              <FileUploader
                onChange={handleMediaChange}
                fileName='videoDoc'
                defaultPreview={mediaPreview['videoDoc']}
                type='video'
                uploadType='mpg_docs'
                label='Vídeo selfie'
                onEvent={handleUploadEvents}
                isRefundAccount={isRefundAccount}
              />
            </div>

            <br />

            <Grid item xs={12}>
              <div className='bank__helper-text'>
                Envie arquivos nos formatos: AVI, MP4, MKV, MOV, WMV ou WEBM. De no máximo 35mb. <br />
                <br />
              </div>
            </Grid>
          </Grid>

          <br />
        </>
      )}

      {imgError ? (
        <Grid item xs={12}>
          <div className='bank__error'>{imgError}</div>
          <div className='m16'></div>
        </Grid>
      ) : (
        <div className='m16'></div>
      )}
    </Grid>
  );
};

export default PersonalDocuments;
